import React from 'react';
import { Check } from 'lucide-react';
import { useGame } from '../contexts/GameContext';
import { useSettings } from '../contexts/SettingsContext';
import * as wordUtils from '../utils/wordUtils';

const PlayerInput = () => {
  const { 
    playerInput, 
    setPlayerInput, 
    handleSubmit, 
    currentWord, 
    isNgRule,
    timeLeft,
    wordChain
  } = useGame();
  
  const { settings } = useSettings();
  
  // Calculate time bar percentage
  const timePercentage = settings.timeLimit > 0 
    ? (timeLeft / settings.timeLimit) * 100 
    : 100;
  
  const lastLetter = wordUtils.getLastLetter(currentWord);
  // Get the effective letter for matching (handling Uyghur vowel rules)
  const effectiveLetter = wordUtils.getEffectiveLetterForMatching(lastLetter);
  
  // Get a hint message based on the letter requirement
  const getHintMessage = () => {
    if (!currentWord) {
      return "بىر سۆز كىرگۈزۈپ ئويۇننى باشلاڭ...";
    }
    
    if (isNgRule) {
      return "خالىغان ھەرپ بىلەن باشلانغان سۆز كىرگۈزۈڭ...";
    }
    
    const vowelsRequiringHamza = ['ا', 'ە', 'و', 'ۆ', 'ۇ', 'ۈ', 'ى', 'ې'];
    
    if (vowelsRequiringHamza.includes(lastLetter)) {
      return `"ئ${lastLetter}" بىلەن باشلانغان سۆز كىرگۈزۈڭ...`;
    }
    
    return `"${lastLetter}" بىلەن باشلانغان سۆز كىرگۈزۈڭ...`;
  };
  
  return (
    <div>
      {currentWord && (
        <div className="text-center mb-4">
          <p className="text-gray-600 mb-1 uyghur-text">ھازىرقى سۆز:</p>
          <div className="text-2xl font-bold text-emerald-700 mb-2">
            {currentWord}
          </div>
          <p className="text-gray-600 uyghur-text">
            {!isNgRule
              ? (wordUtils.getEffectiveLetterForMatching(lastLetter) === 'ئ' 
                 ? `كېيىنكى سۆز "ئ${lastLetter}" بىلەن باشلىنىشى كېرەك`
                 : `كېيىنكى سۆز "${lastLetter}" بىلەن باشلىنىشى كېرەك`)
              : "خالىغان ھەرپ بىلەن باشلانغان سۆز كىرگۈزەلەيسىز"}
          </p>
        </div>
      )}
      
      {/* Time bar */}
      {settings.timeLimit > 0 && (
        <div className="h-2 bg-gray-200 rounded-full mb-4 overflow-hidden">
          <div 
            className={`h-full transition-all duration-1000 ease-linear ${
              timePercentage > 66 
                ? 'bg-emerald-500' 
                : timePercentage > 33 
                  ? 'bg-yellow-500' 
                  : 'bg-red-500'
            }`}
            style={{ width: `${timePercentage}%` }}
          ></div>
        </div>
      )}
      
      <div className="flex gap-2">
        <input
          type="text"
          dir="rtl"
          value={playerInput}
          onChange={(e) => setPlayerInput(e.target.value)}
          placeholder={getHintMessage()}
          className="flex-1 input-field text-right uyghur-text"
          style={{ fontFamily: "UKIJ Ekran, Arial, sans-serif" }}
          onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
          autoFocus
        />
        <button
          onClick={handleSubmit}
          className="btn btn-primary px-6"
        >
          <Check size={20} />
        </button>
      </div>
      
      {/* Hint */}
      {settings.showHints && lastLetter && !isNgRule && (
        <div className="mt-3 text-xs text-gray-500 uyghur-text">
          <span className="font-medium">
            {effectiveLetter === 'ئ' ? `ئ${lastLetter}` : lastLetter}
          </span> بىلەن باشلىنىدىغان سۆزلەرگە مىسال: {wordUtils.generateHintForLetter(lastLetter)}
        </div>
      )}
    </div>
  );
};

export default PlayerInput;